module.exports = __webpack_public_path__ + "img/bb.45c62450.svg";